import React, { FC } from 'react';

import ProLabel from 'components/labels/ProLabel';
import PublicLabel from 'components/labels/PublicLabel';
import DefaultLabel from 'components/labels/DefaultLabel';

import { useMe } from 'graphql/hooks/user';
import { useEvent } from 'components/context/EventContext';

import useStyles from './style';

const Labels: FC = () => {
  const classes = useStyles();

  const { isAdmin } = useMe();
  const { event } = useEvent();

  const template = (event as unknown) as Template;

  return (
    <div className={classes.labels}>
      {isAdmin && template?.isDefault ? <DefaultLabel /> : null}
      {template?.isPro ? <ProLabel /> : null}
      {template?.isPublic ? <PublicLabel /> : null}
    </div>
  );
};

export default Labels;
